import { useEffect, useState } from "react";

export function useHiddenChatBubble() {
  const [
    shouldToggleChatBubbleWhenUnMounted,
    setShouldToggleChatBubbleWhenUnMounted,
  ] = useState(true);

  /**
   * Hide the chat bubble to avoid interaction with existing UI elements
   */
  useEffect(() => {
    const hideChatPopup = () => {
      try {
        if (window.$chatwoot && window.$chatwoot.hideMessageBubble) {
          setShouldToggleChatBubbleWhenUnMounted(false);
        } else if (
          window.$chatwoot &&
          typeof window.$chatwoot.toggleBubbleVisibility === "function"
        ) {
          window.$chatwoot.toggleBubbleVisibility("hide");
        }
      } catch (error) {
        console.warn("Failed to hide Chatwoot bubble:", error);
      }
    };

    // Incase bubble is already present hide it.
    if (window.$chatwoot?.hasLoaded) hideChatPopup();

    // Else, wait for it to load, and then hide it.
    window.addEventListener("chatwoot:ready", hideChatPopup);

    return () => {
      window.removeEventListener("chatwoot:ready", hideChatPopup);
      try {
        if (
          window.$chatwoot?.hasLoaded &&
          shouldToggleChatBubbleWhenUnMounted &&
          typeof window.$chatwoot.toggleBubbleVisibility === "function"
        ) {
          window.$chatwoot.toggleBubbleVisibility("show");
        }
      } catch (error) {
        console.warn("Failed to show Chatwoot bubble:", error);
      }
    };
  }, [shouldToggleChatBubbleWhenUnMounted]);
}
